import React, { useLayoutEffect } from 'react';
import { Layout } from '../../components/common/Layout';
import { DirectionsTable } from '../../components/analytics/DirectionsTable';

export const DirectionsPage: React.FC = () => {
    const title = 'Направления';

    useLayoutEffect(() => {
        document.body.style.backgroundColor = 'white';
        document.body.style.backgroundImage = '';
    });

    return (
        <Layout title={title}>
            <DirectionsTable />
        </Layout>
    );
};
